'use strict';

var addressHelpers = require('./checkout/address');
var shippingHelpers = require('./checkout/shipping');
var utils = require('./utils');

function copyAddresses($form) {
    const $addressSearch = $('input[name$=_addressSearch]', $form);
    const $address1 = $('input[name$=_address1]', $form);
    const isSearch = $('.toogle-addr-search .search', $form).hasClass('d-none');
    const $source = isSearch ? $address1 : $addressSearch;
    const $receiver = isSearch ? $addressSearch : $address1;
    var hasValue = false;
    $receiver.val($source.val());

    try {
        hasValue = $receiver.val().length > 0;
    } catch (e) {
        // continue
    }

    if (!hasValue) {
        $receiver.siblings('.form-control-label').removeClass('form-control-label--float-up');
    }

    // Move focus to the first focusable element in the newly revealed content
    // to meet WCAG 2.4.3 (Focus Order) and WCAG 3.3.1 (Error Identification) requirements
    // Scan through all required fields and check which ones should be considered based on mode
    // Also include addressSearch even if it doesn't have required attribute (UK site issue)
    var $requiredFields = $form.find('input[required], select[required]');

    // Ensure addressSearch is included if it exists and isn't already in the list
    if ($addressSearch.length > 0) {
        var addressSearchIncluded = false;
        $requiredFields.each(function () {
            if ($(this).is($addressSearch)) {
                addressSearchIncluded = true;
                return false;
            }
            return true;
        });

        if (!addressSearchIncluded) {
            $requiredFields = $requiredFields.add($addressSearch);
        }
    }

    var $firstEmptyOrError = null;

    $requiredFields.each(function () {
        var $field = $(this);

        // Skip if field or its parents are not visible
        if (!$field.is(':visible')) {
            return true;
        }

        // Check if field is in a wrapper that should be hidden based on current mode
        var $searchWrapper = $field.closest('.shipping-search-wrapper');
        var $manualWrapper = $field.closest('.shipping-fields-wpapper');

        // When in manual mode (isSearch=false, .search span visible, manual fields shown):
        // - Skip fields that are inside .shipping-search-wrapper (search is hidden)
        // - Include fields that are inside .shipping-fields-wpapper (manual is visible)
        // - Include fields that are not in either wrapper (general fields like name, phone, etc)
        if (!isSearch && $searchWrapper.length > 0) {
            return true; // Skip search wrapper fields in manual mode
        }

        // When in search mode (isSearch=true, .manual span visible, search field shown):
        // - Skip fields that are inside .shipping-fields-wpapper (manual is hidden)
        // - Include fields that are inside .shipping-search-wrapper (search is visible)
        // - Include fields that are not in either wrapper (general fields like name, phone, etc)
        if (isSearch && $manualWrapper.length > 0) {
            return true; // Skip manual wrapper fields in search mode
        }

        var $formGroup = $field.closest('.form-group');
        var hasError = $formGroup.hasClass('is-invalid') || $field.hasClass('is-invalid');
        var isEmpty = !$field.val() || !$field.val().trim();

        if (isEmpty || hasError) {
            $firstEmptyOrError = $field;
            return false; // Break the loop
        }
        return true; // Continue to next iteration
    });

    // If found an empty or invalid required field, focus on it (WCAG 3.3.1)
    // Otherwise focus on the appropriate address field based on mode (WCAG 2.4.3)
    if ($firstEmptyOrError) {
        $firstEmptyOrError.focus();
    } else if (hasValue) {
        // If the receiver already has a value, focus on it
        $receiver.focus();
    } else if (isSearch) {
        // Switching from manual to search mode - focus on search input
        $addressSearch.focus();
    } else {
        // Switching from search to manual mode - focus on first address field
        $address1.focus();
    }
}

function isPCAItemMilitary(item, loqateMilitaryAddressExclusionsRegex) {
    var result = false;
    if (item && loqateMilitaryAddressExclusionsRegex) {
        if ((item.Description && loqateMilitaryAddressExclusionsRegex.test(item.Description))
            || (item.Text && loqateMilitaryAddressExclusionsRegex.test(item.Text))
        ) {
            result = true;
        }
    }
    return result;
}

function addrStatus($input) {
    var statusId = ($input.attr('aria-describedby') || '').split(/\s+/).find(function (id) {
        return id && id.endsWith('-addrStatus');
    });
    return statusId ? $('#' + statusId) : $();
}

var politeSayTimer;
function politeSay($el, text) {
    clearTimeout(politeSayTimer);
    politeSayTimer = setTimeout(function () {
        if ($el.text() === text) $el.text('');
        setTimeout(function () {
            $el.text(text);
        }, 50);
    }, 250);
}

// ===== A11Y helpers for address autocomplete =====
function ensureAddrA11y($input) {
    // combobox hints on the input
    $input.attr({
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-haspopup': 'listbox',
        'aria-expanded': 'false'
    });

    // create per-input polite status (live region)
    var id = $input.attr('id') || ('addr-' + Math.random().toString(36).slice(2));
    $input.attr('id', id);
    var statusId = id + '-addrStatus';
    if (!$('#' + statusId).length) {
        $('<div>', {
            id: statusId,
            role: 'status',
            'aria-live': 'polite',
            'aria-atomic': 'true',
            class: 'sr-only'
        }).prependTo('body');
    }

    // link status to input for context
    var describedby = ($input.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (describedby.indexOf(statusId) === -1) {
        describedby.push(statusId);
        $input.attr('aria-describedby', describedby.join(' '));
    }
}

$(document).ready(function () {
    var key = window.loqateKey;
    var billingKey = window.loqateBillingKey;
    var addressBookKey = window.loqateAddressBookKey;
    var language = 'en';
    var LIMIT = 7;
    var previousCountry = '';
    var addrId = '';
    var focusedIndex = -1;
    var suggestionItems = [];
    var loqateMilitaryAddressExclusions = $('#loqateMilitaryAddressExclusions').length ? $('#loqateMilitaryAddressExclusions').val() : null;
    var loqateMilitaryAddressExclusionsRegex = loqateMilitaryAddressExclusions && loqateMilitaryAddressExclusions.length > 0 ? new RegExp(loqateMilitaryAddressExclusions) : null;

    $('body').on('click', '.toogle-addr-search', function () {
        var $this = $(this);
        var parent = $(this).closest('form');
        $this.find('.search, .manual').toggleClass('d-none');
        parent.find('.shipping-fields-wpapper, .shipping-search-wrapper').toggleClass('d-none');

        // Update aria-label to match the visible span text (which describes the action)
        var $searchSpan = $this.find('.search');
        var $manualSpan = $this.find('.manual');
        if ($searchSpan.hasClass('d-none')) {
            // Manual span is visible after toggle
            $this.attr('aria-label', $manualSpan.text());
        } else {
            // Search span is visible after toggle
            $this.attr('aria-label', $searchSpan.text());
        }

        copyAddresses(parent);
        addressHelpers.methods.manageSubmitBtns();
    });

    $('body').on('keypress', '.billingAddressOne, .shippingAddressOne', function (e) {
        if (e.which === 13) { // Check if Enter key is pressed
            e.preventDefault();
            $(this).closest('form').find('.pcaitem').first()
                .trigger('click');
        }
    });

    $('.shippingCountry, .billingCountry').change(function () {
        var $this = $(this);
        var selectedCountry = $this.val();
        var $form = $this.closest('form');
        var icon = $form.find('.flag-icon-background');

        if (previousCountry === selectedCountry) {
            if (icon && !icon.hasClass('flag-icon-rounded') && selectedCountry !== '') {
                icon.removeClass().addClass('flag-icon-background flag-icon-squared flag-icon-rounded flag-icon-' + $this.val().toLowerCase());
                icon.closest('div').addClass('flag-padding');
            }
            return;
        }
        previousCountry = selectedCountry;

        var countryPrefix = utils.getCountryCodePrefixByCountryCode(selectedCountry) || '';
        $form.find('.shippingcountryCodeDropdownPrefix, .billingcountryCodeDropdownPrefix').val(countryPrefix).trigger('change');
        $form.find('.shippingcountryCodePrefix, .billingcountryCodePrefix').val(countryPrefix.split('_')[1] || countryPrefix).trigger('input');
        $('.js_country-code-dropdown', $form).removeClass('d-none');
        $('.js_country-code-input', $form).addClass('d-none');

        if ($form.hasClass('shipping-form') && !shippingHelpers.methods.getGlobaleCountry(selectedCountry)) {
            shippingHelpers.methods.updateShippingMethodList($form);
        }

        if ($this.val() !== '') {
            icon.removeClass().addClass('flag-icon-background flag-icon-squared flag-icon-rounded flag-icon-' + $this.val().toLowerCase());
            icon.closest('div').addClass('flag-padding');
        } else {
            icon.removeClass().addClass('flag-icon-background');
            icon.closest('div').removeClass('flag-padding');
        }
    });

    $(document).on('click', function (event) {
        if (!$(event.target).hasClass('pcaitem') && !$(event.target).hasClass('shippingAddressOne') && !$(event.target).hasClass('billingAddressOne')) {
            $('.pca').hide();
            $('.shippingAddressOne, .billingAddressOne').attr('aria-expanded', 'false');
        }
    });
    $('body').on('click', '.pcaitem', function () {
        var $this = $(this);
        var parent = $this.closest('form');
        var input = parent.find('.shippingAddressOne, .billingAddressOne');
        var inputTwo = parent.find('.shippingAddressTwo, .billingAddressTwo');
        var line1 = $this.attr('title');
        var isUKSite = window.siteID && window.siteID.toLowerCase().includes('uk');
        addrId = $this.attr('id');

        if ($this.hasClass('pcaexpandable')) {
            input.val(line1).trigger('input').focus();
        } else {
            var isShipping = $(input).hasClass('shippingAddressOne');
            var isBilling = $(input).hasClass('billingAddressOne');
            var isAddressBook = $(input).parents('.address-form').length > 0;

            var apiKey = key;
            if (isBilling && billingKey) {
                apiKey = billingKey;
            } else if (isAddressBook && addressBookKey) {
                apiKey = addressBookKey;
            }

            $.post('https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.10/json3.ws', {
                Key: apiKey,
                Id: addrId,
                IsMiddleware: false,
                Container: addrId,
                Language: language
            }, function (data) {
                //  an error check
                if (!(data.Items.length === 1 && typeof (data.Items[0].Error) !== 'undefined')) {
                    var item = data.Items[0];
                    if (item) {
                        if (isShipping && $('#LoqatePOBoxShippingAddress').length > 0 && item.POBoxNumber) sessionStorage.setItem('loqatePOBoxSelected', true);
                        input.val(item.Line1).trigger('focusin').trigger('change');
                        parent.find('.shippingAddressCity, .billingAddressCity').val(item.City).trigger('focusin');
                        parent.find('.shippingZipCode, .billingZipCode').val(item.PostalCode).trigger('focusin');
                        inputTwo.val(item.Line2).trigger('focusin').trigger('focusout');
                        if (item.ProvinceCode) parent.find('.shippingState, .billingState').val(item.ProvinceCode).trigger('focusin');
                        if (item.CountryIso2) parent.find('.shippingCountry, .billingCountry').val(item.CountryIso2).trigger('change');
                        parent.find('.toogle-addr-search').trigger('click');
                        $('button.submit-shipping').removeClass('d-none disabled');
                        $('div.suggested-address').attr('class', 'suggested-address');
                        if (item.SubBuilding && item.SubBuilding.trim() !== '' && !isUKSite) {
                            var inputVal = input.val();
                            var inputTwoVal = inputTwo.val();

                            // Add SubBuilding to address2 and remove fro address1 if present, for non-UK sites as UK address format does not typically use sub-building
                            if (inputVal.toLowerCase().includes(item.SubBuilding.toLowerCase())) {
                                input.val(inputVal.replace(new RegExp(item.SubBuilding, 'i'), '').trim());
                            }
                            if (!inputTwoVal.toLowerCase().includes(item.SubBuilding.toLowerCase())) {
                                inputTwo.val((inputTwoVal ? inputTwoVal + ' ' : '') + item.SubBuilding).trigger('change');
                            }
                        }

                        if (isShipping) {
                            if ($('#LoqateCommercialShippingAddress').length > 0 && item.Type === 'Commercial') $('#LoqateCommercialShippingAddress').val(input.val() + inputTwo.val() + item.City + item.ProvinceCode + item.PostalCode);
                            if ($('#LoqatePOBoxShippingAddress').length > 0 && item.POBoxNumber) $('#LoqatePOBoxShippingAddress').val(input.val() + inputTwo.val() + item.City + item.ProvinceCode + item.PostalCode);
                            if ($('#LoqateShippingAddress').length > 0) $('#LoqateShippingAddress').val(input.val() + inputTwo.val() + item.City + item.ProvinceCode + item.PostalCode);
                        } else if (isBilling) {
                            if ($('#LoqateBillingAddress').length > 0) $('#LoqateBillingAddress').val(input.val() + inputTwo.val() + item.City + item.ProvinceCode + item.PostalCode);
                        }
                    }
                }
                addrId = '';
                parent.find('.pca').hide();
                input.attr('aria-expanded', 'false');
                addressHelpers.methods.manageSubmitBtns();
            });
        }
    });

    $('body').on('input', '.billingAddressOne, .shippingAddressOne', function () {
        var $this = $(this);
        var parent = $this.closest('fieldset').length ? $this.closest('fieldset') : $this.closest('form');
        var form = $this.closest('form');
        $('button.submit-shipping').removeClass('d-none');
        $('div.suggested-address').attr('class', 'suggested-address');
        // Exclude execution if the element has the 'skip-js-search' class
        if ($this.hasClass('skip-js-search')) {
            return;
        }
        var mapping = {
            US: 'USA',
            GG: 'GGY',
            JE: 'JEY',
            GB: 'GBR',
            AT: 'AUT',
            BE: 'BEL',
            CZ: 'CZE',
            DK: 'DNK',
            EE: 'EST',
            FI: 'FIN',
            FR: 'FRA',
            DE: 'DEU',
            GR: 'GRC',
            HU: 'HUN',
            IE: 'IRL',
            IT: 'ITA',
            LV: 'LVA',
            LT: 'LTU',
            LU: 'LUX',
            NL: 'NLD',
            PL: 'POL',
            PT: 'PRT',
            SK: 'SVK',
            ES: 'ESP',
            SE: 'SWE',
            CH: 'CHE',
            NO: 'NOR',
            BA: 'BIH',
            HR: 'HRV',
            MK: 'MKD',
            ME: 'MNE',
            RS: 'SRB',
            SI: 'SVN',
            LI: 'LIE',
            MC: 'MCO'
        };
        // If a country is selected, send only that country; otherwise, send the full list
        var selectedCountry = form.find('.shippingCountry').val() || form.find('.billingCountry').val();
        var listofCountries;
        if (selectedCountry && mapping[selectedCountry]) {
            listofCountries = mapping[selectedCountry];
        } else {
            listofCountries = 'GGY,JEY,GBR,AUT,BEL,CZE,DNK,EST,FIN,FRA,DEU,GRC,HUN,IRL,ITA,LVA,LTU,NLD,POL,PRT,SVK,ESP,SWE,CHE,NOR,BIH,HRV,MKD,MNE,SRB,SVN,LIE,LUX,MCO';
        }
        if ($this.hasClass('billingAddressOne')) {
            listofCountries = 'USA,' + listofCountries;
        }
        let filters = '';
        if (selectedCountry === 'GG') {
            filters = 'Locality:Guernsey';
        } else if (selectedCountry === 'JE') {
            filters = 'Locality:Jersey';
        }
        var text = $this.val();
        var origin = form.find('.shippingCountry').val() || form.find('.shippingCountry option:eq(0)').val() || form.find('.shippingCountry option:eq(1)').val() || form.find('.billingCountry').val() || form.find('.billingCountry option:eq(0)').val() || form.find('.billingCountry option:eq(1)').val();
        origin = mapping[origin]; // current country
        var countries = origin === 'USA' ? origin : listofCountries;


        // Find or create the .pca container
        var inputId = $this.attr('id') || ('addr-' + Math.random().toString(36).slice(2));
        $this.attr('id', inputId);
        var listId = inputId + '-addrList';
        var container = parent.find('.pca');
        if (container.length === 0) {
            container = $('<div>').addClass('pca').attr({
                id: listId,
                role: 'listbox'
            });
            $this.after(container);
        } else {
            container.empty(); // Clear previous results
            container.attr({
                id: listId,
                role: 'listbox'
            });
        }

        var apiKey = key;
        if ($this.hasClass('billingAddressOne') && billingKey) {
            apiKey = billingKey;
        } else if ($this.parents('.address-form').length > 0 && addressBookKey) {
            apiKey = addressBookKey;
        }

        $.post('https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws', {
            Key: apiKey,
            Text: text,
            IsMiddleware: false,
            Container: addrId,
            Origin: origin,
            Countries: countries,
            Limit: LIMIT,
            Language: language,
            Bias: '',
            Filters: filters,
            GeoFence: ''
        }, function (data) {
            if (!(data.Items.length === 1 && typeof (data.Items[0].Error) !== 'undefined')) {
                data.Items.forEach(function (item, index) {
                    var isMilitary = isPCAItemMilitary(item, loqateMilitaryAddressExclusionsRegex);
                    if (!isMilitary) {
                        var div = $('<div>').addClass('pcaitem')
                            .addClass(item.Type === 'Address' ? '' : 'pcaexpandable')
                            .addClass(index === 0 ? 'pcafirstitem' : '')
                            .attr('title', item.Text)
                            .attr('id', item.Id)
                            .attr('role', 'option')
                            .attr('aria-selected', 'false');
                        // Generate innerHTML with <b> tags based on boldSegments
                        var innerHTML = '';
                        var boldSegments = [];
                        item.Highlight.split(',').forEach(function (segment) {
                            var range = segment.split('-').map(function (num) {
                                return parseInt(num, 10);
                            });
                            if (!isNaN(range[0]) && !isNaN(range[1])) {
                                boldSegments.push({
                                    start: range[0],
                                    end: range[1]
                                });
                            }
                        });

                        var currentIndex = 0;
                        boldSegments.forEach(function (segment) {
                            innerHTML += item.Text.substring(currentIndex, segment.start);
                            innerHTML += '<b>' + item.Text.substring(segment.start, segment.end + 1) + '</b>';
                            currentIndex = segment.end + 1;
                        });
                        innerHTML += item.Text.substring(currentIndex);
                        innerHTML += '<br><span class="pcadescription">' + item.Description + '</span>';

                        div.html(innerHTML);
                        container.append(div);
                    }
                });

                suggestionItems = container.find('.pcaitem');
                suggestionItems.each(function () {
                    $(this).attr('tabindex', '0');
                });
                if (addrId) addrId = ''; // Reset addrId if needed
                var $input = $this;
                ensureAddrA11y($input);
                var $status = addrStatus($input);
                var count = suggestionItems.length;
                if (count) {
                    container.show();
                    $input.attr({ 'aria-controls': listId, 'aria-expanded': 'true' });
                    politeSay($status, count + ' suggestions available. Use up and down arrows to review and Enter to select.');
                } else {
                    container.hide();
                    $input.attr('aria-expanded', 'false');
                    politeSay($status, 'No suggestions.');
                }
            }
        });
    });

    $('body').on('keydown', '.billingAddressOne, .shippingAddressOne, .pcaitem', function (e) {
        if (suggestionItems.length > 0 && $('.pca').is(':visible')) {
            if (e.key === 'Tab') {
                e.preventDefault();
                suggestionItems.attr('aria-selected', 'false');
                if (e.shiftKey) {
                    focusedIndex = ((focusedIndex - 1) + suggestionItems.length) % suggestionItems.length;
                } else {
                    focusedIndex = (focusedIndex + 1) % suggestionItems.length;
                }
                suggestionItems.eq(focusedIndex).attr('aria-selected', 'true').focus();
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                suggestionItems.attr('aria-selected', 'false');
                focusedIndex = (focusedIndex + 1) % suggestionItems.length;
                suggestionItems.eq(focusedIndex).attr('aria-selected', 'true').focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                suggestionItems.attr('aria-selected', 'false');
                focusedIndex = ((focusedIndex - 1) + suggestionItems.length) % suggestionItems.length;
                suggestionItems.eq(focusedIndex).attr('aria-selected', 'true').focus();
            } else if (e.key === 'Enter' && $(this).hasClass('pcaitem')) {
                e.preventDefault();
                $(this).trigger('click');
                focusedIndex = 0;
            } else if (e.key === 'Escape' && $(this).hasClass('pcaitem')) {
                e.preventDefault();
                $('.pca').hide();
                focusedIndex = -1;
                var $input = $('.billingAddressOne, .shippingAddressOne');
                $input.attr('aria-expanded', 'false').focus();
            }
        }
    });

    $('body').on('click', '.select-shipping-address-type-new', function () {
        setTimeout(function () {
            var addressMode = $('#dwfrm_billing').attr('data-address-mode');
            if (addressMode === 'new' && $('.billingCountry').val()) {
                $('.billingCountry').closest('.form-group').find('label').addClass('form-control-label--float-up');
            }
        }, 300);
    });
});
